export default "__VITE_PUBLIC_ASSET__6195d559__"